/*
 *   File : selectBox.js
 *   Author : https://evoqueinnovativelab.com
 *   Description : Input box
 *   Integrations : null
 *   Version : 1.0.0
 *   Created : 09-12-2021
 */

/*import package*/
import React, { useRef, useState } from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';


/*import style*/
import styles from '../../styles/components/selectBox.module.scss';
import { useEffect } from 'react';

const SelectBox = (props) => {
	const wrapperRef = useRef(null);
	const [menuIsOpen, setMenuIsOpen] = useState(false);


	useEffect(() => {
		let isMounted = true;
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) {
						// wrapper scrolled out of view
						setMenuIsOpen(false);
					}
				});
			},
			{ threshold: 0 } // trigger as soon as it leaves viewport
		);

		if (wrapperRef.current) {
			observer.observe(wrapperRef.current);
		}

		return () => {

			isMounted = false;

			if (wrapperRef.current) {
				observer.unobserve(wrapperRef.current);
			}

			observer.disconnect();
		};
	}, []);

	/* --- passing value to selectbox ----*/
	const valueChange = (e) => {
		props.selectchange(e)
	}
	const customStyles = {
		placeholder: (defaultStyles) => ({
			...defaultStyles,
			color: "#010101",
			fontWeight: "400",
			lineHeight: "18px",
			fontSize: "14px",
			opacity: '0.27'
		}),
		valueContainer: (defaultStyles) => ({
			...defaultStyles,
			flexWrap: "nowrap",
			whiteSpace: "nowrap",
			color: '#010101',
		}),
		singleValue: (defaultStyles) => ({
			...defaultStyles,
			color: '#010101',
			fontSize: "14px",
		}),
		menuPortal: base => ({ ...base, zIndex: 9999 }),
		menu: base => ({ ...base, zIndex: 9999 }),
		control: (defaultStyles) => ({
			...defaultStyles,
			border: `0.5px solid #d2d2d2 `,
			borderRadius: `8px`,
			color: '#010101',
			width: props.width ?? "",
			minHeight: props.minHeight ?? `48px`,
			backgroundColor: '#ffffff',
			cursor: "pointer",
			opacity: 1,
			overflow: "visible",
			boxShadow: "none",
			'&:hover': {
				borderColor: `#d2d2d2`,
				boxShadow: "none"
			}
		}),
		indicatorContainer: (defaultStyles) => ({
			...defaultStyles,
			padding: "4px"
		}),
		menuList: (defaultStyles) => ({
			...defaultStyles,
			minHeight: "200px",
			fontSize: "14px",
		})
	}


	return (
		<div ref={wrapperRef} style={{ overflowY: "auto" }}>
			{props.type === 2 ?
				<CreatableSelect
					closeMenuOnSelect={props.selectType === true ? false : true}
					// components={{ ClearIndicator }}

					isSearchable={props.isSearchable}
					isClearable={props.isClearable}
					//eslint-disable-next-line
					styles={customStyles}
					className={`${styles.e_select_box}` + " " + props.className}
					onChange={(e) => { valueChange(e) }}
					isDisabled={props.isDisabled}
					onMenuOpen={() => setMenuIsOpen(true)}
					onMenuClose={() => setMenuIsOpen(false)}
					options={props.options}
					value={props.value ? props.value : null}
					isMulti={props.selectType}
					placeholder={props.placeholder}
					menuPosition="fixed"
					menuPortalTarget={document.body}
					menuIsOpen={menuIsOpen}
					defaultValue={props.defaultValue}
					// menuIsOpen={true}
					{...props} />
				:
				<Select
					closeMenuOnSelect={props.selectType === true ? false : true}
					// components={{ ClearIndicator }}

					isSearchable={props.isSearchable}
					isClearable={props.isClearable}
					//eslint-disable-next-line
					styles={customStyles}
					className={`${styles.e_select_box}` + " " + props.className}
					onChange={(e) => { valueChange(e) }}
					isDisabled={props.isDisabled}
					onMenuOpen={() => setMenuIsOpen(true)}
					onMenuClose={() => setMenuIsOpen(false)}
					options={props.options}
					value={props.value ? props.value : ""}
					isMulti={props.selectType}
					placeholder={props.placeholder}
					menuPosition="fixed"
					menuPortalTarget={document.body}
					menuIsOpen={menuIsOpen}
					defaultValue={props.defaultValue}
					// menuIsOpen={true}
					{...props} />}
		</div>
	);
}

export default SelectBox;
